import { yupResolver } from "@hookform/resolvers/yup";
import { MobileStickyCtaContent } from "api/shop";
import { PaziaFormButton, PaziaInput } from "components/atoms";
import { FormProvider, useForm } from "react-hook-form";
import * as yup from "yup";
import { ButtonVariantSelect } from "./ButtonVariantSelect";

interface MobileStickyCtaFormProps {
  onSubmit: (data: MobileStickyCtaFormValues) => void;
  onCancel: () => void;
  defaultValues?: MobileStickyCtaContent;
  isLoading?: boolean;
}

export const MobileStickyCtaForm = ({ onSubmit, onCancel, defaultValues, isLoading }: MobileStickyCtaFormProps) => {
  const methods = useForm<FormValues>({
    resolver: yupResolver(schema) as any,
    defaultValues: {
      buttonText: defaultValues?.buttonText ?? "Zapisz się",
      anchorId: defaultValues?.anchorId ?? "",
      subtitleText: defaultValues?.subtitleText ?? "",
      buttonVariant: defaultValues?.buttonVariant ?? "primary",
    },
  });

  const handleFormSubmit = (data: FormValues) => {
    const formattedData: MobileStickyCtaFormValues = {
      buttonText: data.buttonText,
      anchorId: data.anchorId || undefined,
      subtitleText: data.subtitleText || undefined,
      buttonVariant: data.buttonVariant || "primary",
    };
    onSubmit(formattedData);
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(handleFormSubmit)} className="grid gap-4">
        <PaziaInput name="buttonText" label="Tekst przycisku" placeholder="np. Zapisz się" required />
        <PaziaInput name="anchorId" label="ID kotwicy (opcjonalnie)" placeholder="np. enrollment" />
        <PaziaInput name="subtitleText" label="Tekst pod przyciskiem (opcjonalnie)" placeholder="np. Ostatnie wolne miejsca!" />
        <ButtonVariantSelect name="buttonVariant" label="Styl przycisku" />

        <div className="flex justify-end gap-2 border-t border-slate-200 pt-4 dark:border-slate-600">
          <button
            type="button"
            onClick={onCancel}
            className="rounded-lg border border-slate-300 px-4 py-2 text-slate-700 transition-colors hover:bg-slate-50 dark:border-slate-600 dark:text-slate-300 dark:hover:bg-slate-700"
          >
            Anuluj
          </button>
          <PaziaFormButton disabled={isLoading} />
        </div>
      </form>
    </FormProvider>
  );
};

const schema = yup
  .object({
    buttonText: yup.string().required("Tekst przycisku jest wymagany"),
    anchorId: yup.string().optional(),
    subtitleText: yup.string().optional(),
    buttonVariant: yup.string().optional(),
  })
  .required();

interface FormValues {
  buttonText: string;
  anchorId?: string;
  subtitleText?: string;
  buttonVariant?: string;
}

export interface MobileStickyCtaFormValues {
  buttonText: string;
  anchorId?: string;
  subtitleText?: string;
  buttonVariant?: string;
}
